import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'raf/polyfill';
import 'babel-polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import App from './App.js';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import i18n from './i18n';
import store from './store';

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
//if (module.hot) { module.hot.accept(App);}
